// extracted by mini-css-extract-plugin
export default {"requisite":"Requisite_requisite__5-vyH","addProduct":"Requisite_addProduct__TR1g9","table":"Requisite_table__9ntCV"};